import axios from 'axios';
import { AUTH_BEARER_TOKEN_KEY } from 'src/constants';
import { getLocalStorageItem } from 'src/hooks/useLocalStorage';
import { clientAuthRealm, centralAuthRealm, getApiUrl } from 'src/utils/env';

const axiosInstance = axios.create({
  baseURL: getApiUrl(),
  // default is bracket format: ?id[]=1&id[]=2
  // indexes null is replicated param format: ?id=1&id=2
  paramsSerializer: {
    indexes: null
  }
});

axiosInstance.interceptors.request.use(
  config => {
    const token = getLocalStorageItem<string>(AUTH_BEARER_TOKEN_KEY);

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    config.headers['X-Client-Name'] = 'submission-client';
    // config.headers['X-Client-Version'] = '1.0.0';

    config.headers['X-Auth-Realm'] = clientAuthRealm;
    config.headers['X-Auth-Central-Auth-Realm'] = centralAuthRealm;

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
